<template>
    <div>
        <div id="example-table"></div>
    </div>
</template>

<script>
import alert_mixins from '../mixins/alertify.jsx';
export default {
    mixins : [alert_mixins],
    props : {
        seafarer_id : {

        }
    },
    data(){
        return {

        }
    },
    methods : {
        view(data){
            window.location = "/vessel/view/"+data.id
        },
        deleteVessel(data){
            const com_this = this;
             alertify.confirm('Are you sure to delete this vessel?',function(e){
                if(e){
                axios.post('/vessel/delete_vessel',{
                    id : data.getRow().getData().id
                }).then(res => {
                    if(res.data.status == "SUCCESS"){
                        com_this.alert({
                            alert_type : "success",
                            title : "Vessel deletion",
                            alert_msg : "success",
                            msg : "Vessel successfully deleted."
                        }).set({title: "Vessel deletions"});
                        data.getRow().delete()
                    }
                }).catch(res => {
                    alert(res.data)
                }) 
                    }
                }).set({title: "Vessel deletion"});
        }
    },
    mounted(){
                const com_this = this;
            var deleteIcon = function(){
                    return "<i class='fas fa-trash-alt'></i>";
                }
                var obj0 = {
                    formatter: deleteIcon,
                    width:40,
                    align:"center",
                    cellClick:function(e, cell){com_this.deleteVessel(cell)}
                }
                var viewIcon = function(){
                    return "<i class='fas fa-file'></i>";
                }
                var obj1 = {
                    formatter: viewIcon,
                    width:40,
                    align:"center",
                    cellClick:function(e, cell){com_this.view(cell.getRow().getData())}
                }

        var table = new Tabulator("#example-table", {
            height:"311px",
            layout:"fitColumns",
            ajaxURL:"/seafarer_embarkment/embark_history?seafarer_id="+this.seafarer_id,
            ajaxProgressiveLoad:"scroll",
            paginationSize:20,
            groupBy : 'vessel_name',
            pagination:"remote",
            placeholder:"No Data Set",
            groupToggleElement:"header",
            selectable:true,
            columns:[
                {title:"SYSID", field:"id", sorter:"string",width : 80},
                {title:"Seafarer Name", field:"seaf_name", sorter:"string", width : 150},
                {title:"Vessel Name", field:"vessel_name", sorter:"string", sortable:false, width : 150},
                {title:"Embarkation Date", field:"start_date", sorter:"string", sortable:false, width : 180},
                {title:"Disembarkation Date", field:"end_date", sorter:"string", sortable:false, width : 180},
                {title:"Back-to-Back", field:"bac_to_back", sorter:"string", sortable:false, width : 150},
                {title:"Embarked By", field:"user_email", sorter:"string", sortable:false, width : 150},
            ],
        });
        // table.addColumn(obj0)
        // table.addColumn(obj1)











    }
}
</script>

<style scoped>


</style>
